const light = {
  colors: {
    primary: "#020202",
    secondary: "#F5F5F5",
    disabledOverlay: "rgb(255,255,255,0.75)",
    text: "#4B4B4B",
    tersier: "#ABAEC7",
    background: "#FEFEFE",
  },
};

const dark = {
  colors: {
    primary: "#FFFFFF",
    secondary: "#202022",
    disabledOverlay: "rgb(21,21,21,0.75)",
    text: "#C9C9C9",
    tersier: "#ABAEC7",
    background: "#151515",
  },
};

export const themes = { light, dark };
